import * as angular from 'angular';

import { ComponentDefinition, DateRange } from '../../models/';
import { IUserService, IAuthenticationService, ILoggerService } from '../../services/';
import { rangeSelected } from '../../common/';
import { IRootScope } from 'IRootScope';

class LastDatesButtonController implements angular.IComponentController {

    selectedDates: DateRange[];
    
    readonly format: string;
    
    private _user: string;
    
    static $inject = [
        '$rootScope',
        'userService',
        'authenticationService',
        'loggerService'
    ];
    constructor(
        private _$rootScope: IRootScope,
        private _userService: IUserService,
        _authenticationService: IAuthenticationService,
        private _loggerService: ILoggerService
    ) {
        this._user = _authenticationService.authentication.userName;
    }

    $onInit() {
        this.refreshDates();
    }

    refreshDates() {
        this._userService.getSelectedDatesForUser(this._user).then(data => {
            this.selectedDates = data.selectedDates;
        }).catch(() => {
            this._loggerService.logError('Cannot load saved dates for user');
        });
    }

    selectDate(range: DateRange): void {
        this._$rootScope.$broadcast(rangeSelected, range);
    }
}

export const wtLastDatesButton: ComponentDefinition = {
    componentId: 'wtLastDatesButton',
    controller: LastDatesButtonController,
    template: require('./lastDatesButton.component.html'),
    controllerAs: 'vm',
    bindings: {
        canNavigate: '<',
        format: '<'
    }
};